import React, { useEffect, useState } from "react";
import api from "~/services/api";
import HandleFormData from "~/utils/HandleFormData";
import { Label, Input, Select, TextArea } from "~/componentes/CustomForm";
import ColoredFileInput from "~/componentes/CustomForm/FileInput/styles/ColoredFileInput";

import { Container, ThisCardItem } from "./styles";
import { Materialize } from "~/styles/materializeGrid";

function CreateEditContent({ mountedData }) {
  const [abaAtiva, setAbaAtiva] = useState(0);
  const abas = [
    { titulo: "Projeto" },
    { titulo: "Processos" },
    { titulo: "Acessos" }
  ];

  const [etapas, setEtapas] = useState([]);
  const [contratos, setContratos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [cliente, setCliente] = useState(mountedData ? mountedData?.cliente : {});
  const [solicitantes, setSolicitantes] = useState([]);
  const [coordenadores, setCoordenadores] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [recursos, setRecursos] = useState([]);
  const [atividades, setAtividades] = useState([]);
  const [acessos, setAcessos] = useState([]);
  const [prioridade, setPrioridade] = useState({});
  const [idEtapa, setIdEtapa] = useState(mountedData ? mountedData?.idEtapa : 1);
  const [horaTotal, setHoraTotal] = useState(mountedData ? mountedData?.horaTotal : 0);
  const [horaSaldo, setHoraSaldo] = useState(mountedData ? mountedData?.horaSaldo : 0);
  const [gerarProjeto, setGerarProjeto] = useState(false);
  const [removeArquivos, setRemoveArquivos] = React.useState([]);
  const [ativo, setAtivo] = useState(
    !mountedData ? "true" : mountedData?.ativo ? "true" : "false",
  );

  useEffect(() => {
    if (mountedData) {
      setHoraTotal(mountedData?.horaTotal);
      setHoraSaldo(mountedData?.horaSaldo);
      api.get("/signed/empresa/gestorprojeto/etapa/etapas", { params: { ativo: 1, tipo: "PRJ" } }).then((r) => {
        setEtapas(r?.data);
        setIdEtapa(mountedData?.idEtapa);
      });
    } else {
      api.get("/signed/empresa/gestorprojeto/etapa/etapas", { params: { ativo: 1, tipo: "PRJ", posicao: 1 } }).then((r) => {
        setEtapas(r?.data);
        if (r?.data?.length > 0) {
          setIdEtapa(r?.data[0]?.id);
        }
      });
    }

    api.get("/signed/empresa/suporte/contratos", { params: { ativo: 1, listContrato: true } }).then((r) => setContratos(r?.data));
    api.get("/signed/empresa/gestorprojeto/cliente/clientes", { params: { ativo: 1 } }).then((r) => setClientes(r?.data));
    api.get("/signed/empresa/gestorprojeto/gerencia/coordenadores", { params: { ativo: 1 } }).then((r) => setCoordenadores(r?.data));
    api.get("/signed/empresa/gestorprojeto/gerencia/produtos", { params: { ativo: 1 } }).then((r) => setProdutos(r?.data));
  }, []);

  useEffect(() => {
    if (cliente?.id) {
      cliente?.id && api.get("/signed/empresa/gestorprojeto/gerencia/clientesolicitantes", { params: { ativo: 1, idCliente: cliente?.id } }).then((r) => setSolicitantes(r?.data));
    } else {
      setSolicitantes([])
    }
  }, [cliente]);

  return (
    <Container defaultScroll={true}>
      <Materialize className="materialize">
        <div className="row no-margin">
          <Label title="Título" className="col s12 m12 l12">
            <Input name="titulo" disabled="true" required="true" defaultValue={mountedData?.projeto?.titulo} />
          </Label>
        </div>
        <div className='card-subitem'>
          <ThisCardItem cabecalho={true}>
            <div className="col col3">
              <p>Atividade</p>
            </div>
            <div className="col col2">
              <p>Analista</p>
            </div>
            <div className="col col5">
              <p>Titulo</p>
            </div>
            <div className="col col2">
              <p>Usuário</p>
            </div>
            <div className="col col1 center">
              <p>Data</p>
            </div>
            <div className="col col1 center">
              <p>Hora</p>
            </div>
          </ThisCardItem>
          {mountedData?.historico?.map((thisAtiv, o) => (
            <ThisCardItem>
              <div className="col col3">
                <p>{thisAtiv?.projetoAtividade?.titulo ? thisAtiv?.projetoAtividade?.titulo : "-"}</p>
              </div>
              <div className="col col2">
                <p>{thisAtiv?.projetoAtividadeAnalista?.analista?.nome ? thisAtiv?.projetoAtividadeAnalista?.analista?.nome : "-"}</p>
              </div>
              <div className="col col5">
                <p>{thisAtiv?.titulo}</p>
              </div>
              <div className="col col2">
                <p>{thisAtiv?.usuarioCadastro?.nome}</p>
              </div>
              <div className="col col1 center">
                <p>{((new Date(thisAtiv?.dataCadastro).toLocaleString('pt-BR', { timeZone: 'UTC' })).split(","))[0]}</p>
              </div>
              <div className="col col1 center">
                <p>{thisAtiv?.horaCadastro}</p>
              </div>
            </ThisCardItem>
          ))}
        </div>
      </Materialize>
    </Container>
  );
}

export default CreateEditContent;
